import * as React from 'react';
import {useSelector} from 'react-redux';

import * as selectors from 'nutshell-core/territories/territories-selectors';

// @ts-expect-error - imported from .js/.jsx file

import {TerritoryIcon} from 'shells/icon/svg/territory-icon';
import {SelectPickerGeneric} from 'shells/select-picker-generic/select-picker-generic';

import {appHistory} from '../../../history';
import type {NutshellState} from '../../../store';

export const PEEP_TERRITORY_SELECT_ID = 'peep-territory-select';

type Props = {
    territoryId: string | null | undefined;
    onUpdatePeepTerritory: (territoryId?: string | null | undefined) => void;
    isDisabled?: boolean;
    canAccessSetup: boolean;
};

export function PeepTerritorySelect(props: Props) {
    const {territoryId, onUpdatePeepTerritory, isDisabled, canAccessSetup} = props;

    // @ts-expect-error
    const territories = useSelector((state: NutshellState) => selectors.getAll(state, null));

    // @ts-expect-error
    const onChangePeepTerritory = (selectedTerritory) => {
        if (isDisabled) return;

        onUpdatePeepTerritory(selectedTerritory ? selectedTerritory.id : null);
    };

    let selectedTerritory;
    if (territoryId) {
        // @ts-expect-error
        selectedTerritory = territories.find((territory) => territory.id === territoryId);
    }

    return (
        <SelectPickerGeneric
            inputId={PEEP_TERRITORY_SELECT_ID}
            options={territories}
            valueKey='id'
            labelKey='name'
            value={selectedTerritory}
            onChange={onChangePeepTerritory}
            onClear={onChangePeepTerritory}
            controlIcon={TerritoryIcon}
            hideDividerWhenEmpty={true}
            isDisabled={isDisabled}
            footerButton={
                canAccessSetup
                    ? {
                          label: 'Manage territories',
                          onClick: () => {
                              appHistory.push('/setup/territory');
                          },
                      }
                    : undefined
            }
        />
    );
}
